import { msalInstance } from "../index";
import { loginRequest, protectedResources } from "../config/authConfig";

export const getToken = async () => {
  try {
    const account = msalInstance.getActiveAccount();

    if (!account) {
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    }

    const response = await msalInstance.acquireTokenSilent({
      account: account,
      scopes: protectedResources.api.scopes,
    });

    return response.accessToken;
  } catch (e) {
    msalInstance.loginRedirect(loginRequest);
  }
  return "";
};

export async function _downloadFetch(request: string | URL | globalThis.Request, options: RequestInit) {
  var res = await fetch(request, options);

  if (res.ok) {
    const result = await res.blob();
    return result;
  }
  var errorResult = await res.json();
  const responseError = {
    message: errorResult.message || "Something went wrong",
    code: errorResult.statusCode || "",
    stackTrace: errorResult.stackTrace || null,
  };

  let error = new Error();
  error = { ...error, ...responseError };
  throw error;
}

//TODO: should there be a promise with a return type for error handling these fetches?
export async function _fetch(request: string | URL | globalThis.Request, options: RequestInit) {
  const fetchResult = await fetch(request, options);
  const result = await fetchResult.json();

  if (fetchResult.ok) {
    return result;
  }
  const responseError = {
    errorCode: result.errorCode || "InternalServerError",
    code: result.statusCode || 500,
  };

  let error = new Error(responseError.errorCode);

  throw error;
}
